import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../core/Logger.js";
import { isSome as e, isNone as i } from "../../core/maybe.js";
import { webglValidateShadersEnabled as r } from "./checkWebGLError.js";
import { ResourceType as s, DepthStencilAttachment as h } from "./enums.js";
import n from "./Renderbuffer.js";
import o from "./Texture.js";
import { getGpuMemoryUsage as c } from "./Util.js";
var a = t.getLogger("esri.views.webgl.FrameBufferObject");

var l = /*#__PURE__*/function () {
  function l(t, i) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, l);

    if (this._context = t, this._glName = null, this._depthAttachment = null, this._stencilAttachment = null, this._colorAttachments = new Map(), this._initialized = !1, this._desc = _objectSpread({}, i), t.instanceCounter.increment(s.Framebuffer, this), e(r)) {
      Array.isArray(r) || (r = [r]);

      for (var _e = 0; _e < r.length; ++_e) {
        var c, a;
        var _i = r[_e];

        var _s = void 0;

        d(_i) ? (_s = _i.descriptor, this._colorAttachments.set(36064 + _e, _i)) : (_s = _i, this._colorAttachments.set(36064 + _e, new o(t, _i))), 0 !== (null == (c = this._desc) ? void 0 : c.colorTarget) && 2 !== (null == (a = this._desc) ? void 0 : a.colorTarget) && console.error("Framebuffer is initialized with a texture however the descriptor indicates using a renderbuffer color attachment!"), this._validateColorAttachmentPoint(36064 + _e), this._validateTextureDimensions(_s, this._desc);
      }
    }

    if (h instanceof n) {
      var _l;

      var _t = null != (_l = this._desc.depthStencilTarget) ? _l : 3;

      2 === _t ? this._stencilAttachment = h : 1 === _t || 3 === _t ? this._depthAttachment = h : console.error('If a Renderbuffer is provided, "depthStencilTarget" must be one of STENCIL_RENDER_BUFFER, DEPTH_RENDER_BUFFER or DEPTH_STENCIL_RENDER_BUFFER'), u(h.descriptor, this._desc);
    } else if (e(h)) {
      var _t2;

      this._context.capabilities.depthTexture || console.error("Extension WEBGL_depth_texture isn't supported therefore it is no possible to set the depth/stencil texture as an attachment!"), d(h) ? (this._depthStencilTexture = h, _t2 = h.descriptor) : this._depthStencilTexture = new o(this._context, h), this._validateTextureDimensions(_t2, this._desc);
    }
  }

  _createClass(l, [{
    key: "dispose",
    value: function dispose() {
      if (!this._desc) return;

      var t = this._context.getBoundFramebufferObject();

      if (this._disposeColorAttachments(), this._disposeDepthStencilAttachments(), this._glName) {
        this._context.gl.deleteFramebuffer(this._glName), this._glName = null;
      }

      this._context.bindFramebuffer(t), this._context.instanceCounter.decrement(s.Framebuffer, this), this._desc = null;
    }
  }, {
    key: "glName",
    get: function get() {
      return this._glName;
    }
  }, {
    key: "descriptor",
    get: function get() {
      return this._desc;
    }
  }, {
    key: "colorTexture",
    get: function get() {
      var t = this._colorAttachments.get(36064);

      return t && d(t) ? t : null;
    }
  }, {
    key: "colorAttachment",
    get: function get() {
      return this._colorAttachments.get(36064);
    }
  }, {
    key: "depthStencilAttachment",
    get: function get() {
      return this._depthStencilTexture || this._depthAttachment || this._stencilAttachment;
    }
  }, {
    key: "depthStencilTexture",
    get: function get() {
      return this._depthStencilTexture;
    }
  }, {
    key: "width",
    get: function get() {
      return this._desc.width;
    }
  }, {
    key: "height",
    get: function get() {
      return this._desc.height;
    }
  }, {
    key: "gpuMemoryUsage",
    get: function get() {
      return c(this.colorAttachment) + c(this.depthStencilAttachment);
    }
  }, {
    key: "getColorTexture",
    value: function getColorTexture(t) {
      var e = this._colorAttachments.get(t);

      return e && d(e) ? e : null;
    }
  }, {
    key: "framebufferTexture2D",
    value: function framebufferTexture2D(t, e) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 36064;
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3553;
      var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      e.framebufferTexture2D(e.FRAMEBUFFER, i, r, t, s);
    }
  }, {
    key: "attachColorTexture",
    value: function attachColorTexture(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 36064;
      if (!t) return;

      this._validateColorAttachmentPoint(e);

      var i = t.descriptor;
      this._validateTextureDimensions(i, this._desc), this._disposeColorAttachments(), this._initialized && (this._context.bindFramebuffer(this), this.framebufferTexture2D(t.glName, this._context.gl, e)), this._colorAttachments.set(e, t);
    }
  }, {
    key: "detachColorTexture",
    value: function detachColorTexture() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 36064;

      var e = this._colorAttachments.get(t);

      if (d(e)) {
        var _i2 = e;
        return this._initialized && (this._context.bindFramebuffer(this), this.framebufferTexture2D(null, this._context.gl, t)), this._colorAttachments.delete(t), _i2;
      }
    }
  }, {
    key: "attachDepthStencilTexture",
    value: function attachDepthStencilTexture(t) {
      if (i(t)) return;
      var e = t.descriptor;
      34041 !== e.pixelFormat && console.error("Depth/Stencil texture must have a pixel type of DEPTH_STENCIL!"), 34042 !== e.dataType && console.error("Depth/Stencil texture must have data type of UNSIGNED_INT_24_8!"), this._context.capabilities.depthTexture || console.error("Extension WEBGL_depth_texture isn't supported therefore it is no possible to set the depth/stencil texture!"), this._validateTextureDimensions(e, this._desc), this._desc.depthStencilTarget && 4 !== this._desc.depthStencilTarget && (this._desc.depthStencilTarget = 4), this._disposeDepthStencilAttachments(), this._initialized && (this._context.bindFramebuffer(this), this.framebufferTexture2D(t.glName, this._context.gl, h)), this._depthStencilTexture = t;
    }
  }, {
    key: "detachDepthStencilTexture",
    value: function detachDepthStencilTexture() {
      var t = this._depthStencilTexture;
      return t && this._initialized && (this._context.bindFramebuffer(this), this.framebufferTexture2D(null, this._context.gl, h)), this._depthStencilTexture = null, t;
    }
  }, {
    key: "attachDepthStencilBuffer",
    value: function attachDepthStencilBuffer(t) {
      if (i(t)) return;
      var e = t.descriptor;

      if (34041 !== e.internalFormat && 33189 !== e.internalFormat && console.error("Depth/Stencil buffer must have correct internalFormat"), u(e, this._desc), this._disposeDepthStencilAttachments(), this._desc.depthStencilTarget = 34041 === e.internalFormat ? 3 : 1, this._initialized) {
        this._context.bindFramebuffer(this);

        var _e2 = this._context.gl,
            _i3 = 1 === this._desc.depthStencilTarget ? _e2.DEPTH_ATTACHMENT : _e2.DEPTH_STENCIL_ATTACHMENT;

        _e2.framebufferRenderbuffer(_e2.FRAMEBUFFER, _i3, _e2.RENDERBUFFER, t.glName);
      }

      this._depthAttachment = t;
    }
  }, {
    key: "detachDepthStencilBuffer",
    value: function detachDepthStencilBuffer() {
      var t = this._context.gl,
          e = this._depthAttachment;

      if (e && this._initialized) {
        this._context.bindFramebuffer(this);

        var _e3 = 1 === this._desc.depthStencilTarget ? t.DEPTH_ATTACHMENT : t.DEPTH_STENCIL_ATTACHMENT;

        t.framebufferRenderbuffer(t.FRAMEBUFFER, _e3, t.RENDERBUFFER, null);
      }

      return this._depthAttachment = null, e;
    }
  }, {
    key: "detachAll",
    value: function detachAll() {
      this.detachColorTexture(), this.detachDepthStencilBuffer(), this.detachDepthStencilTexture();
    }
  }, {
    key: "copyToTexture",
    value: function copyToTexture(t, e, i, r, s, h, n) {
      (t < 0 || e < 0 || s < 0 || h < 0) && console.error("Offsets cannot be negative!"), (i <= 0 || r <= 0) && console.error("Copy width and height must be greater than zero!");
      var c = this._desc,
          a = n.descriptor;
      3553 !== n.descriptor.target && console.error("Texture target must be TEXTURE_2D!"), (t + i > c.width || e + r > c.height || s + i > a.width || h + r > a.height) && console.error("Bad dimensions, the current input values will attempt to read or copy out of bounds!");

      var _l2 = this._context,
          d = _l2.bindTexture(n, o.TEXTURE_UNIT_FOR_UPDATES);

      _l2.bindFramebuffer(this), _l2.gl.copyTexSubImage2D(3553, 0, s, h, t, e, i, r), _l2.bindTexture(d, o.TEXTURE_UNIT_FOR_UPDATES);
    }
  }, {
    key: "readPixels",
    value: function readPixels(t, e, i, r, s, h, n) {
      (i <= 0 || r <= 0) && console.error("Copy width and height must be greater than zero!"), n || console.error("Target memory is not initialized!"), this._context.bindFramebuffer(this);

      this._context.gl.readPixels(t, e, i, r, s, h, n);
    }
  }, {
    key: "resize",
    value: function resize(t, e) {
      var i = this._desc;

      if (i.width !== t || i.height !== e) {
        if (!this._initialized) return i.width = t, i.height = e, this._colorAttachments.forEach(function (i) {
          i && i.resize(t, e);
        }), void (this._depthStencilTexture && this._depthStencilTexture.resize(t, e));
        i.width = t, i.height = e, this._colorAttachments.forEach(function (i) {
          i && i.resize(t, e);
        }), null != this._depthStencilTexture ? this._depthStencilTexture.resize(t, e) : (this._depthAttachment || this._stencilAttachment) && (this._depthAttachment && this._depthAttachment.resize(t, e), this._stencilAttachment && this._stencilAttachment.resize(t, e)), this._context.getBoundFramebufferObject() === this && this._context.bindFramebuffer(null), this._initialized = !1;
      }
    }
  }, {
    key: "initializeAndBind",
    value: function initializeAndBind() {
      var _this = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3553;
      var e, i, s, h;
      var c = this._context.gl;
      if (this._initialized) return void c.bindFramebuffer(c.FRAMEBUFFER, this.glName);
      this._glName && c.deleteFramebuffer(this._glName);

      var a = this._context,
          _l3 = c.createFramebuffer(),
          u = this._desc,
          f = null != (e = u.colorTarget) ? e : 1,
          m = null != (i = u.width) ? i : 1,
          T = null != (s = u.height) ? s : 1;

      if (c.bindFramebuffer(c.FRAMEBUFFER, _l3), 0 === this._colorAttachments.size) if (0 === f) this._colorAttachments.set(36064, _(a, u, 2 === this.descriptor.colorTarget ? 34067 : 3553));else {
        var _t3 = new n(a, {
          internalFormat: 32854,
          width: m,
          height: T
        });

        this._colorAttachments.set(36064, _t3);
      }

      this._colorAttachments.forEach(function (e, i) {
        e && (d(e) ? _this.framebufferTexture2D(e.glName, c, i, t) : c.framebufferRenderbuffer(c.FRAMEBUFFER, c.COLOR_ATTACHMENT0, c.RENDERBUFFER, e.glName));
      });

      var p = null != (h = u.depthStencilTarget) ? h : 0;

      switch (p) {
        case 1:
        case 3:
          {
            this._depthAttachment || (this._depthAttachment = new n(a, {
              internalFormat: 1 === u.depthStencilTarget ? 33189 : 34041,
              width: m,
              height: T
            }));

            var _t4 = 1 === p ? c.DEPTH_ATTACHMENT : c.DEPTH_STENCIL_ATTACHMENT;

            c.framebufferRenderbuffer(c.FRAMEBUFFER, _t4, c.RENDERBUFFER, this._depthAttachment.glName);
            break;
          }

        case 2:
          this._stencilAttachment || (this._stencilAttachment = new n(a, {
            internalFormat: 36168,
            width: m,
            height: T
          })), c.framebufferRenderbuffer(c.FRAMEBUFFER, c.STENCIL_ATTACHMENT, c.RENDERBUFFER, this._stencilAttachment.glName);
          break;

        case 4:
          if (!this._depthStencilTexture) {
            a.capabilities.depthTexture || console.error("Extension WEBGL_depth_texture isn't supported therefore it is no possible to set the depth/stencil texture as an attachment!");
            var _t5 = {
              target: 3553,
              pixelFormat: 34041,
              dataType: 34042,
              samplingMode: 9728,
              wrapMode: 33071,
              width: m,
              height: T
            };
            this._depthStencilTexture = new o(a, _t5);
          }

          this.framebufferTexture2D(this._depthStencilTexture.glName, c, c.DEPTH_STENCIL_ATTACHMENT, t);
      }

      if (r()) {
        c.checkFramebufferStatus(c.FRAMEBUFFER) !== c.FRAMEBUFFER_COMPLETE && console.error("Framebuffer is incomplete!");
      }

      this._glName = _l3, this._initialized = !0;
    }
  }, {
    key: "_disposeColorAttachments",
    value: function _disposeColorAttachments() {
      var _this2 = this;

      this._colorAttachments.forEach(function (t, e) {
        if (d(t)) _this2._initialized && (_this2._context.bindFramebuffer(_this2), _this2.framebufferTexture2D(null, _this2._context.gl, e)), t.dispose();else if (t instanceof WebGLRenderbuffer) {
          var _i4 = _this2._context.gl;
          _this2._initialized && (_this2._context.bindFramebuffer(_this2), _i4.framebufferRenderbuffer(_i4.FRAMEBUFFER, e, _i4.RENDERBUFFER, null)), _this2._context.gl.deleteRenderbuffer(t);
        }
      }), this._colorAttachments.clear();
    }
  }, {
    key: "_disposeDepthStencilAttachments",
    value: function _disposeDepthStencilAttachments() {
      var t = this._context.gl;

      if (this._depthAttachment) {
        if (this._initialized) {
          this._context.bindFramebuffer(this);

          var _e4 = 1 === this._desc.depthStencilTarget ? t.DEPTH_ATTACHMENT : t.DEPTH_STENCIL_ATTACHMENT;

          t.framebufferRenderbuffer(t.FRAMEBUFFER, _e4, t.RENDERBUFFER, null);
        }

        this._depthAttachment.dispose(), this._depthAttachment = null;
      }

      this._stencilAttachment && (this._initialized && (this._context.bindFramebuffer(this), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.STENCIL_ATTACHMENT, t.RENDERBUFFER, null)), this._stencilAttachment.dispose(), this._stencilAttachment = null), this._depthStencilTexture && (this._initialized && (this._context.bindFramebuffer(this), this.framebufferTexture2D(null, t, t.DEPTH_STENCIL_ATTACHMENT)), this._depthStencilTexture.dispose(), this._depthStencilTexture = null);
    }
  }, {
    key: "_validateTextureDimensions",
    value: function _validateTextureDimensions(t, e) {
      3553 !== t.target && 34067 !== t.target && console.error("Texture type must be TEXTURE_2D or TEXTURE_CUBE_MAP!"), void 0 !== e.width && e.width >= 0 && void 0 !== e.height && e.height >= 0 ? e.width === t.width && e.height === t.height || console.error("Color attachment texture must match the framebuffer's!") : (e.width = t.width, e.height = t.height);
    }
  }, {
    key: "_validateColorAttachmentPoint",
    value: function _validateColorAttachmentPoint(t) {
      if (-1 === l._MAX_COLOR_ATTACHMENTS) {
        var _t6 = this._context.capabilities.drawBuffers;

        if (_t6) {
          var _e5 = this._context.gl;
          l._MAX_COLOR_ATTACHMENTS = _e5.getParameter(_t6.MAX_COLOR_ATTACHMENTS);
        } else l._MAX_COLOR_ATTACHMENTS = 1;
      }

      var e = t - 36064;
      e + 1 > l._MAX_COLOR_ATTACHMENTS && a.error("esri.FrameBufferObject", "illegal attachment point for color attachment: ".concat(e + 1, ". Implementation supports up to ").concat(l._MAX_COLOR_ATTACHMENTS, " color attachments"));
    }
  }]);

  return l;
}();

function d(t) {
  return "type" in t && "texture" === t.type;
}

function _(t, e, i) {
  return new o(t, {
    target: i,
    pixelFormat: 6408,
    dataType: 5121,
    samplingMode: 9728,
    wrapMode: 33071,
    width: e.width,
    height: e.height
  });
}

function u(t, e) {
  void 0 !== e.width && e.width >= 0 && void 0 !== e.height && e.height >= 0 ? e.width === t.width && e.height === t.height || console.error("Renderbuffer dimensions must match the framebuffer's!") : (e.width = t.width, e.height = t.height);
}

l._MAX_COLOR_ATTACHMENTS = -1;
export { l as default };